module.exports = __webpack_public_path__ + "img/s-l640.d34c4a0b.jpg";